import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useI18nStore } from '@/store/i18nStore';

// Layouts
import MainLayout from '@/layouts/MainLayout';
import AuthLayout from '@/layouts/AuthLayout';

// Pages
import LandingPage from '@/pages/LandingPage';
import LoginPage from '@/pages/auth/LoginPage';
import RegisterPage from '@/pages/auth/RegisterPage';
import DashboardPage from '@/pages/DashboardPage';
import BoxListPage from '@/pages/movement/BoxListPage';
import BoxDetailPage from '@/pages/movement/BoxDetailPage';
import JoinMovementPage from '@/pages/movement/JoinMovementPage';
import LedgerPage from '@/pages/ledger/LedgerPage';
import ProfilePage from '@/pages/ProfilePage';
import NotFoundPage from '@/pages/NotFoundPage';
import PrivacyPage from '@/pages/PrivacyPage';
import CookiePolicyPage from '@/pages/CookiePolicyPage';
import HowItWorksPage from '@/pages/HowItWorksPage';
import AdminPage from '@/pages/admin/AdminPage';
import ReferralPage from '@/pages/referral/ReferralPage';
import SubscriptionPage from '@/pages/subscription/SubscriptionPage';
import ChatPage from '@/pages/ChatPage';
import TicketPage from '@/pages/TicketPage';
import BadgesPage from '@/pages/BadgesPage';

// Guards
import ProtectedRoute from '@/components/guards/ProtectedRoute';
import AdminRoute from '@/components/guards/AdminRoute';

// Components
import CookieBanner from '@/components/CookieBanner';

export default function App() {
  const language = useI18nStore((s) => s.language);

  return (
    <>
      <Helmet>
        <html lang={language} />
        <title>React-City — Movimento del Dono</title>
      </Helmet>

      <Routes>
        {/* Public */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="/come-funziona" element={<HowItWorksPage />} />

        {/* Auth */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
        </Route>

        {/* Protected */}
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/boxes" element={<BoxListPage />} />
            <Route path="/boxes/:id" element={<BoxDetailPage />} />
            <Route path="/join" element={<JoinMovementPage />} />
            <Route path="/ledger" element={<LedgerPage />} />
            <Route path="/referral" element={<ReferralPage />} />
            <Route path="/subscription" element={<SubscriptionPage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/tickets" element={<TicketPage />} />
            <Route path="/badges" element={<BadgesPage />} />
            <Route path="/profile" element={<ProfilePage />} />
          </Route>
        </Route>

        {/* Admin (solo admin/super_admin) */}
        <Route element={<AdminRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/admin" element={<AdminPage />} />
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <CookieBanner />
    </>
  );
}
